import FailedFetchError from '../errors/FailedFetchError';

interface RetryConfig {
  intervalsMS: number[];
}

export const wait = (ms: number) =>
  new Promise(resolve => {
    setTimeout(resolve, ms);
  });

export const retryOnException = async <T>(invokeOperation: () => Promise<T>, config: RetryConfig): Promise<T> => {
  let nextMSInterval: number | undefined = 0;
  let error = new Error('No calls made');
  while (nextMSInterval !== undefined) {
    try {
      if (nextMSInterval > 0) {
        await wait(nextMSInterval);
      }
      return await invokeOperation();
    } catch (e) {
      if (e instanceof Error) {
        error = e;
      } else if (typeof e === 'string') {
        error = new Error(e);
      } else if (typeof e === 'object') {
        try {
          error = new Error('No error instance thrown for invokeOperation: ' + JSON.stringify(e));
        } catch (jsonError) {
          error = new Error('No error instance thrown for invokeOperation: ' + String(e));
        }
      } else {
        error = new Error('No error instance thrown for invokeOperation: ' + String(e));
      }

      // Retry ONLY when the error is a network error.
      // RestClient.ts throws 'FailedFetchError' for network errors
      // and 'HttpError' for Client/Server errors.
      if (error instanceof FailedFetchError) {
        nextMSInterval = config.intervalsMS.shift();
      } else {
        nextMSInterval = undefined;
      }
    }
  }
  throw error;
};
